export default "__VITE_ASSET__QHlKVR$f__"